import { applicationCountries } from '@/shared/tools/applicationCountries'
import PropTypes from 'prop-types'
import CountryFlag from '@/shared/components/CountryFlag/CountryFlag'
import { RAIL_BUTTON_INSET, RAIL_ICON_SIZE } from '@/shared/theme/railSlot'

const FLAG_SIZE = 24

const ApplicationCountry = ({ country, floating = false }) => {
  const flag = applicationCountries[country] || ''
  if (!flag) return null

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: floating ? 'flex-start' : 'center',
        alignSelf: floating ? 'stretch' : 'auto',
        paddingLeft: floating ? `calc(${RAIL_BUTTON_INSET} + ${(RAIL_ICON_SIZE - FLAG_SIZE) / 2}px)` : 0,
        alignItems: 'center',
        flexShrink: 0,
        height: floating ? '1.6875rem' : '10px',
        marginBottom: floating ? 0 : '2rem',
      }}
    >
      <CountryFlag country={country} size={FLAG_SIZE} />
    </div>
  )
}

ApplicationCountry.propTypes = {
  country: PropTypes.string.isRequired,
  floating: PropTypes.bool,
}

export default ApplicationCountry
